"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QR_EVENT_LOGIN = exports.QR_EVENT_BACKUP = exports.QR_AUTH_REFRESHABLE = exports.QR_AUTH_REFRESH = exports.QR_AUTH_LOADING = void 0;
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
// Used to sync extension popup loading state for QRAuth.
var QR_AUTH_LOADING = exports.QR_AUTH_LOADING = 'QR_AUTH_LOADING';

// Used as a callback after pressing the refresh button in QRAuth.
var QR_AUTH_REFRESH = exports.QR_AUTH_REFRESH = 'QR_AUTH_REFRESH';

// Used to check if QRAuth should show the refresh button.
var QR_AUTH_REFRESHABLE = exports.QR_AUTH_REFRESHABLE = 'QR_AUTH_REFRESHABLE';

// Rendered inside the PDF file containing backup codes for account recovery
// in case the user loses access to the Master Key.
var QR_EVENT_BACKUP = exports.QR_EVENT_BACKUP = 'backup';

// Displayed on the `authenticate` page, used to sign the user into dashboard.
var QR_EVENT_LOGIN = exports.QR_EVENT_LOGIN = 'login';